import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { COUPON_PAGE_NAME } from '../../constants/service/app/couponConstants';
import { CouponGenerateWrap } from '../../views/coupon-v2/generate/CouponGenerateWrap';

const CouponGenerate = () => {
  return (
    <PageTemplate pageName={COUPON_PAGE_NAME.COUPON_GENERATE}>
      <CouponGenerateWrap />
    </PageTemplate>
  );
};

export default CouponGenerate;
